module.exports = __webpack_public_path__ + "ptc_momoro_R2.854a9a6e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/momoro/parent_to_child/ptc_momoro_R2.jpg
// module id = +FnI
// module chunks = 0